export const tabs = [
  "Overview",
  "Companies",
  "Stages",
  "Tasks",
];

export const PROJECT_DOWNLOAD = {
  tabs,
  isAllSelected: true,
};
